/**
 * 页面状态
 * @param {Function} fn1 显示时触发
 * @param {Function} fn2 隐藏时触发
 */
export const pageShowAndHide = (fn1, fn2) => {
  var hiddenProperty =
    'hidden' in document
      ? 'hidden'
      : 'webkitHidden' in document
        ? 'webkitHidden'
        : 'mozHidden' in document
          ? 'mozHidden'
          : null;
  var visibilityChangeEvent = hiddenProperty.replace(
    /hidden/i,
    'visibilitychange'
  );
  var onVisibilityChange = function () {
    if (!document[hiddenProperty]) {
      // 页面显示
      fn1();
    } else {
      // 页面不可见
      fn2();
    }
  };
  document.addEventListener(visibilityChangeEvent, onVisibilityChange);
}

// 检查是否是ios
function checkIsIOS(){
  return /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
}
// 设置滚动元素（兼容性问题）
function setRootScrollTop(value) {
  setScrollTop(window, value);
  setScrollTop(document.body, value);
}
// 设置滚动位置
function setScrollTop(el, value) {
  if ('scrollTop' in el) {
    el.scrollTop = value;
  } else {
    el.scrollTo(el.scrollX, value);
  }
}
// 获取滚动位置
function getRootScrollTop() {
  return (
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0
  );
}

const isIOS = checkIsIOS();
// 执行还原滚动条
export function resetScroll() { // 触发blur事件后会执行该函数
  if (isIOS) {
    //  这是滚动条位置
    setRootScrollTop(getRootScrollTop());
  }
}